module.exports = __webpack_public_path__ + "img/info-cart.774bf062.png";